import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=ad7a2c08&scoped=true"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=ad7a2c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7a2c08",
  null
  
)

export default component.exports